"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectJavaRuntime = void 0;
const static_1 = require("../../inputs/base-runtimes/static");
const parser_1 = require("./parser");
function detectJavaRuntime(extractedLayers) {
    const releaseContent = (0, static_1.getJavaRuntimeReleaseContent)(extractedLayers);
    return releaseContent ? (0, parser_1.parseJavaRuntimeRelease)(releaseContent) : null;
}
exports.detectJavaRuntime = detectJavaRuntime;
//# sourceMappingURL=index.js.map